module.exports = __webpack_public_path__ + "media/images/mapmarker-71c806428f9d8c76f8dd491ee177382c.png";